import {JobRead, ProductionCreate, ProductionRead, ProductionReadWRefs, ProductionResults} from "../schemas";
import {apiFetch} from "./client";

export async function createProduction(productionData: ProductionCreate): Promise<ProductionReadWRefs> {
    return apiFetch<ProductionReadWRefs>("/productions", {method: "POST", body: productionData});
}

export async function getProductions(groupId: string): Promise<ProductionRead[]> {
    const resp = await apiFetch<ProductionResults>("/productions/get_group_productions", {
        params: {group_id: groupId},
    });
    return resp.productions;
}

export async function deleteProduction(productionId: string): Promise<void> {
    await apiFetch<void>(`/productions/${productionId}`, {method: "DELETE"});
}

export async function exportProduction(productionId: string): Promise<JobRead> {
    return apiFetch<JobRead>(`/productions/${productionId}/export`, {method: "POST"});
}

export async function downloadProduction(
    productionId: string,
): Promise<{ download_url: string; expires_in: string }> {
    return apiFetch<{ download_url: string; expires_in: string }>(
        `/productions/${productionId}/download`,
    );
}
